/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Unlink_Confirm_WhatsappInputs */

const he_account_delivery_unlink_confirm_whatsapp = /** @type {(inputs: Account_Delivery_Unlink_Confirm_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לנתק את הווטסאפ?`)
};

const en_account_delivery_unlink_confirm_whatsapp = /** @type {(inputs: Account_Delivery_Unlink_Confirm_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink WhatsApp?`)
};

/**
* | output |
* | --- |
* | "Unlink WhatsApp?" |
*
* @param {Account_Delivery_Unlink_Confirm_WhatsappInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_unlink_confirm_whatsapp = /** @type {((inputs?: Account_Delivery_Unlink_Confirm_WhatsappInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Unlink_Confirm_WhatsappInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_unlink_confirm_whatsapp(inputs)
	return en_account_delivery_unlink_confirm_whatsapp(inputs)
});